import { render } from "./BlogDetailPage.vue?vue&type=template&id=2091af3f&scoped=true"
import script from "./BlogDetailPage.vue?vue&type=script&lang=js"
export * from "./BlogDetailPage.vue?vue&type=script&lang=js"

import "./BlogDetailPage.vue?vue&type=style&index=0&id=2091af3f&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2091af3f"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader});
